import {
  AfterViewChecked,
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormControlName, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[sharedFormInput]',
})
export class FormInputDirective implements OnDestroy, OnInit, AfterViewChecked {
  @Input() sharedFormInput?: string | { [key: string]: string };
  @Input() inputOptions?: { validateOnInit: boolean };

  changeSubscription: Subscription | undefined;

  constructor(
    private el: ElementRef,
    private formControlName: FormControlName,
  ) {}

  ngOnInit() {
    if (this.inputOptions && this.inputOptions.validateOnInit)
      this.validateControl();

    this.changeSubscription =
      this.formControlName.control?.valueChanges?.subscribe(
        this.validateControl.bind(this),
      );
  }

  validateControl() {
    const classList = this.el.nativeElement.classList;
    let invalidFeedBack;

    //IF THE DIRECTIVE IS PROVIDED WITH AN ERROR MESSAGE, CREATE THE ELEMENT TO DISPLAY THAT MESSAGE
    let errorMessage = '';

    if (this.sharedFormInput) {
      invalidFeedBack = document.createElement('div');
      invalidFeedBack.classList.add('invalid-feedback');

      const errors = this.formControlName.errors;

      if (typeof this.sharedFormInput == 'string') {
        errorMessage = this.sharedFormInput;
      } else if (errors) {
        errorMessage = this.sharedFormInput[Object.keys(errors)[0]] || '';
      }

      invalidFeedBack.innerText = errorMessage;
    }

    if (this.formControlName.control.invalid) {
      if (!classList.contains('is-invalid')) classList.add('is-invalid');

      const sibling = this.el.nativeElement.nextElementSibling;

      if (sibling && sibling.classList.contains('invalid-feedback')) {
        sibling.innerText = errorMessage;
      } else if (invalidFeedBack) {
        this.el.nativeElement.after(invalidFeedBack);
      }
    }

    if (
      this.formControlName.control.valid &&
      classList.contains('is-invalid')
    ) {
      classList.remove('is-invalid');
      if (invalidFeedBack) this.el.nativeElement.nextElementSibling.remove();
    }
  }

  ngAfterViewChecked() {
    // Ensure invalid styling is applied after external actions (e.g., submit) that mark controls as touched
    const control = this.formControlName.control;
    const classList = this.el.nativeElement.classList;

    if (control.touched && control.invalid) {
      if (!classList.contains('is-invalid')) classList.add('is-invalid');
    } else if (control.valid && classList.contains('is-invalid')) {
      classList.remove('is-invalid');
    }

    // Maintain required asterisk logic on the next sibling labels
    const sibling = this.el.nativeElement.nextElementSibling;

    if (!sibling?.innerText) return;

    if (control.hasValidator(Validators.required)) {
      if (
        !sibling.innerText.includes('*') &&
        !sibling.classList.contains('invalid-feedback')
      )
        sibling.innerText = sibling.innerText + ' *';
    } else {
      if (
        sibling.innerText.includes('*') &&
        !sibling.classList.contains('invalid-feedback')
      )
        sibling.innerText = sibling.innerText.replace('*', '');
    }
  }

  ngOnDestroy() {
    this.changeSubscription?.unsubscribe();
  }
}
